// @ts-nocheck
import { useEffect, useRef, useState } from "react";
import { FiRefreshCw } from "react-icons/fi";

export const AUTO_REFRESH_INTERVAL_SECONDS = 60;

export function useAutoRefreshCountdown({
  intervalSeconds = AUTO_REFRESH_INTERVAL_SECONDS,
  enabled = true,
  onRefresh,
}) {
  const [refreshCountdownSec, setRefreshCountdownSec] =
    useState(intervalSeconds);
  const onRefreshRef = useRef(onRefresh);

  useEffect(() => {
    onRefreshRef.current = onRefresh;
  }, [onRefresh]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const refreshInterval = setInterval(() => {
      if (!document.hidden) onRefreshRef.current?.(); // skip in background tabs
      setRefreshCountdownSec(intervalSeconds);
    }, intervalSeconds * 1000);

    const countdownInterval = setInterval(() => {
      setRefreshCountdownSec((prev) =>
        prev <= 1 ? intervalSeconds : prev - 1
      );
    }, 1000);

    return () => {
      clearInterval(refreshInterval);
      clearInterval(countdownInterval);
    };
  }, [enabled, intervalSeconds]);

  const resetCountdown = () => setRefreshCountdownSec(intervalSeconds);

  return { refreshCountdownSec, resetCountdown };
}

export function AutoRefreshCountdownButton({
  countdownSec,
  onManualRefresh,
  title = "Auto-refresh data",
}) {
  return (
    <button
      type="button"
      onClick={onManualRefresh}
      style={{
        border: "1px solid #dee2e6",
        background: "#f8f9fa",
        color: "#64748b",
        borderRadius: 999,
        height: 32,
        padding: "0 12px",
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        fontWeight: 600,
        cursor: "pointer",
      }}
      title={title}
    >
      <FiRefreshCw size={13} />
      {countdownSec}s
    </button>
  );
}
